import { useTranslation } from "react-i18next"
import Breadcrumb from "src/components/layouts/Common/Breadcrumb"
import Sidebar from "src/components/layouts/sidebar/Sidebar"
import EditRole from "src/components/panel/roles/EditRole"

const EditRoleView=()=>{
    const {t}=useTranslation()
    return<>
    <Sidebar>
        <Breadcrumb title={t("edit_role_modal_title")} subtitle={t("edit_role_description")}/>
        <EditRole/>
    </Sidebar>
    </>
}
export default EditRoleView